import { Router } from '@angular/router';
import { localStorageKeys } from '../constants/local.storage.keys';
import { ApiService } from './api.service';
var AuthService = /** @class */ (function () {
    function AuthService(router, apiService) {
        this.router = router;
        this.apiService = apiService;
    }
    Object.defineProperty(AuthService, "authorized", {
        get: function () {
            return !!localStorage.getItem(localStorageKeys.authToken);
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.login = function (command) {
        var _this = this;
        return this.apiService.post('auth/login', command)
            .do(function (token) { return _this.apiService.setAuthorizationHeader(token); });
    };
    AuthService.prototype.logout = function () {
        this.apiService.clearAuthorizationHeader();
    };
    return AuthService;
}());
export { AuthService };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/services/auth.service.ts.pre-build-optimizer.js